import script from "./CardPromocao.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPromocao.vue?vue&type=script&setup=true&lang=js"

import "./CardPromocao.vue?vue&type=style&index=0&id=7e589a0b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e589a0b"]])

export default __exports__